import styled from 'styled-components';

export const NavContainer = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e6effc;
  padding: 10px 0;
  gap: 15px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 3px 10px 0px;
`;

export const NavTab = styled.div`
  font-size: clamp(1rem, 3vw, 1.3rem);
  font-weight: ${({ $isActive }) => ($isActive ? '800' : '600')};
  padding: 8px 16px;
  cursor: pointer;
  color: ${({ $isActive }) => ($isActive ? '#1B1C1E' : '#0E0E0F')};
  transition: all 0.1s ease-in-out;

  &:hover {
    background-color: #bdd8ff;
    border-radius: 6px;
  }

  @media (max-width: 450px) {
    padding: 6px 12px;
  }
`;
